<template lang="pug">
.table-toolbar
  .table-toolbar__filters
    div(class="form form-grid")
      BriqInput(
        label="Search" 
        v-model="filters.search" 
        @blur="searchByFreeText"
        @keydown.native="onEnter"
        :hideOptionalMarker="true"
        )
      BriqDateRangePicker(
        id="reservationDate" 
        label="Date of booking" 
        :required="false" 
        :hideOptionalMarker="true" 
        name='booking'
        :value="filters ? filters.reservationDate : ''"
        @dateSelected="searchByBookingDate"
        )
      BriqDateRangePicker(
        id="startDate" 
        label="Date of visit" 
        :required="false" 
        :hideOptionalMarker="true" 
        name='visit' 
        :value="filters ? filters.startDate : ''"
        @dateSelected="searchByVisitDate")
      BriqMenuDropdown(
        label="Booking Status" 
        :items="bookingStatusOptions"
        :activeItem="filters ? filters.status : ''"
        :onClick="searchByStatus"
        )
      BriqMenuDropdown(
        label="Attendance"
        :items="attendanceOptions"
        :activeItem="filters ? filters.attendance : ''"
        :onClick="searchByAttendance"
        )
      BriqCheckbox(label="Unchecked" :value="filters ? filters.unchecked : false" @input="searchByUnchecked")
      BriqButton(@click="resetAllFilters") Reset
</template>

<script>
import { mapGetters } from 'vuex'
import BriqInput from '@/vue/components-global/BriqInput.vue'
import BriqDateRangePicker from '@/vue/components-global/BriqDateRangePicker.vue'
import BriqCheckbox from '@/vue/components-global/BriqCheckbox.vue'
import BriqButton from '@/vue/components-global/BriqButton.vue'
import BriqMenuDropdown from '@/vue/components/BriqMenuDropdown.vue'

export default {
  name: 'BookingsOverviewFilters',
  components: {
    BriqInput,
    BriqDateRangePicker,
    BriqCheckbox,
    BriqButton,
    BriqMenuDropdown
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    ...mapGetters('bookings', ['filters', 'bookingStatusOptions', 'attendanceOptions']),
    ...mapGetters('briqState', ['userHasPermission']),
    userMaySeeAllStatuses() {
      return this.userHasPermission('Frontend_Application_Bookings_Include_All_Statuses')
    }
  },
  methods: {
    onEnter(e) {
      if (e.keyCode === 13) this.$store.dispatch('bookings/fetchBookings')
    },
    searchByFreeText() {
      this.$store.dispatch('bookings/fetchBookings')
    },
    searchByBookingDate(dates) {
      this.applyDateFilter('bookingDate', dates)
    },
    searchByVisitDate(dates) {
      this.applyDateFilter('visitDate', dates)
    },
    searchByStatus(option) {
      this.applyFilter('status', option.id)
    },
    searchByAttendance(option) {
      this.applyFilter('attendance', option.id)
    },
    searchByUnchecked(value) {
      this.applyFilter('unchecked', value)
    },
    async applyFilter(filter, value) {
      await this.$store.dispatch('bookings/setFilter', { filter, value })
      this.$store.dispatch('bookings/fetchBookings')
    },
    async applyDateFilter(filter, dates) {
      await this.$store.dispatch('bookings/setDateFilter', { filter, dates })
      this.$store.dispatch('bookings/fetchBookings')
    },
    async resetAllFilters() {
      this.search = ''
      await this.$store.commit('bookings/clearFilters')
      this.$store.dispatch('bookings/fetchBookings')
    },
    showAllStatusOptions() {
      this.$store.commit('bookings/showAllStatusOptions')
    }
  },
  watch: {
    userMaySeeAllStatuses(newVal) {
      if (newVal === true) this.showAllStatusOptions()
    }
  },
    async created() {
    let query = this.$route?.query

    if (query) {
      let queries = []
      for (const [key, value] of Object.entries(query)) {
          const val = value.replace(/%20/gi, '')
          queries.push({ key, value: val })
      }
      if (queries.length > 0) {
        await this.$store.dispatch('bookings/setFilters', queries)
      }
    }

    this.$store.dispatch('bookings/fetchBookings')

  },
}
</script>

<style lang="stylus">
.form-grid 
  display: grid
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 120px 100px
  gap: 24px
  align-items: flex-end

.input-wrapper
  .menu
    z-index: 10
</style>
